package pl.mothdigital.neuronowi.components.sections.footer

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import pl.mothdigital.neuronowi.components.widgets.FacebookButton
import pl.mothdigital.neuronowi.components.widgets.InstagramButton
import pl.mothdigital.neuronowi.theme.SiteTheme

@Composable
fun FooterMediaButtons() {
    Row {
        FacebookButton(
            buttonColorPalette = SiteTheme.white,
            contentColor = SiteTheme.green._900,
        )
        InstagramButton(
            buttonColorPalette = SiteTheme.white,
            contentColor = SiteTheme.green._900,
        )
    }
}
